import translate from '../translations'

export default {
  name: 'file-upload',

  componentDidMount () {
    this.input = this.el.querySelector('input[type="file"]')
    this.sizeMax =
      this.props && this.props.maxSize ? parseInt(this.props.maxSize) : 1024
    this.sizeMaxMo = (this.sizeMax / 1024).toFixed(2)
    this.sizeOK = false
    this.previewElt =
      this.props && this.props.previewElt
        ? document.querySelector(`#${this.props.previewElt}`)
        : null
    // Check if any file is selected
    this.input.addEventListener('change', () => {
      if (this.input.files.length > 0) {
        if (this.checkSize()) {
          this.previewFile()
        }
      }
    })

    /* this.file = this.el.querySelector('.file')
    /*console.log(this.file)

    /*this.input.on('click', () => {
      if(this.files[0].size >= 1024) {
        alert('file too big');
        this.value = "";
      }
    }) */
  },

  checkSize () {
    for (let i = 0; i <= this.input.files.length - 1; i++) {
      const file = this.input.files.item(i)
      const fileSize = file.size
      const size = Math.round(fileSize / 1024)
      // the size of the file
      if (size >= this.sizeMax) {
        this.sizeOK = false
        alert(`${translate('FILE_TOO_BIG')} ${this.sizeMaxMo}Mo`)
      } else {
        this.sizeOK = true
      }
      return this.sizeOK
    }
  },

  previewFile () {
    var preview = this.previewElt
    if (preview) {
      var file = this.input.files[0]
      var reader = new FileReader()
      const previewIsImage = !!preview.getAttribute('src')

      reader.onloadend = function () {
        if (previewIsImage) {
          preview.src = reader.result
        } else {
          preview.style.backgroundImage = `url('${reader.result}')`
        }
        preview.classList.add('is-sourced')
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    }
  },
}
